import defaultCounter from './default-counter';
import counterWithIcons from './counter-with-icons';

const variations = [defaultCounter, counterWithIcons];

export default variations;
